<template>
  <div id="hresh1x-detail-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM4GEC2']['30'] }}
      </h3>
    </div>
    <div id="tab1" class="panel-collapse collapse in tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC2']['60'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ data.numhmref }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC2']['70'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ setDateOutput(data.dtemistk) }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC2']['80'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color" id="filename" name="filename"><a :href="data.path_filename" target="_blank">{{ data.filename }}</a></div>
                <!-- <div class="form-control readonly-field-color">{{ data.desc_refdoc }}</div> -->
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC2']['90'] }}</label>
              <div class="col-md-5">
                <textarea class="form-control readonly-field-color" readonly="readonly">{{ data.desmist1 }}</textarea>
              </div>
            </div>
          </form>
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hresh1x-detail-tab1',
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>




// WEBPACK FOOTER //
// detailTab1.vue?90aa3274